import { createFileRoute, redirect } from "@tanstack/react-router";

import { ApiKeysPage } from "../iam/organization/components/ApiKeysPage";
import { canViewerAccessOrgSubpage } from "../iam/shared/rules/orgSubpageAccess";
import { accessRole } from "../iam/staff/rules/organizationAccess";

/**
 * Route is /organizations/$organizationId/api-keys: the API keys page, which an owner or an
 * admin manages and a Mountaya staff member reads. Its beforeLoad reads the access the parent
 * guard resolved onto the router context and bounces anybody else — a contributor, a viewer —
 * to the members page through the shared canViewerAccessOrgSubpage predicate, the same rule the
 * sidenav and switcher read, so the guard, the hidden link, and the preserved-tab logic can
 * never disagree. A staff visit renders the keys read-only (ApiKeysPage).
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/api-keys")({
  beforeLoad: ({ context, params }) => {
    const viewer = { role: accessRole(context.access), staff: context.access.staff };
    if (!canViewerAccessOrgSubpage("api-keys", viewer)) {
      throw redirect({
        params: { organizationId: params.organizationId },
        to: "/organizations/$organizationId/members",
      });
    }
  },
  component: ApiKeysPage,
});
